import React from "react";
import cx from "classnames";
import arrowUpIcon from "./assets/arrow-up.svg";
import arrowDownIcon from "./assets/arrow-down.svg";
import styles from "./Table.module.scss";

export interface TableProps {
  className?: string;
  lastColumnRight?: boolean;
}

const Table: React.FC<TableProps> = ({ className, children, lastColumnRight }) => {
  return (
    <table className={cx(styles.table, className, { [styles.lastColumnRight]: lastColumnRight })}>
      {children}
    </table>
  );
};

export interface TableHeadProps {
  className?: string;
}

export const TableHead: React.FC<TableHeadProps> = ({ className, children }) => {
  return <thead className={cx(styles.thead, className)}>{children}</thead>;
};

export interface TableBodyProps {
  className?: string;
}

export const TableBody: React.FC<TableBodyProps> = ({ className, children }) => {
  return <tbody className={cx(styles.tbody, className)}>{children}</tbody>;
};

export interface TableRowProps {
  className?: string;
}

export const TableRow: React.FC<TableRowProps> = ({ className, children }) => {
  return <tr className={cx(styles.tr, className)}>{children}</tr>;
};

export type TableSortDirection = "up" | "down";

export interface TableHeaderProps {
  className?: string;
  active?: boolean;
  sortDirection?: TableSortDirection;
  onSort?: (sortDirection?: TableSortDirection) => void;
}

export const TableHeader: React.FC<TableHeaderProps> = ({
  className,
  children,
  active,
  sortDirection,
  onSort,
}) => {
  const otherProps: React.ThHTMLAttributes<any> = {};
  if (onSort) {
    otherProps.onClick = () => {
      onSort(sortDirection);
    };
  }
  return (
    <th
      className={cx(styles.th, className, { [styles.thActive]: active, [styles.sortable]: onSort })}
      {...otherProps}
    >
      <div className={styles.thBody}>
        {children}
        {sortDirection && (
          <img
            className={styles.sortIcon}
            src={sortDirection === "up" ? arrowUpIcon : arrowDownIcon}
            alt={sortDirection === "up" ? "Ascending" : "Descending"}
          />
        )}
      </div>
    </th>
  );
};

export interface TableCellProps {
  className?: string;
}

export const TableCell: React.FC<TableCellProps> = ({ className, children }) => {
  return <td className={cx(styles.td, className)}>{children}</td>;
};

export default Table;
